<script setup>
import { RouterView } from 'vue-router';
import { useFullScreen } from '@/shared/composables/useFullScreen';
import LoadingOverlay from '@/shared/LoadingOverlay.vue';
import { useLoadingStore } from '@/stores/loading';

useFullScreen();
const loadingStore = useLoadingStore();
</script>

<template>
  <loading-overlay
    :show="loadingStore.isLoading"
    :text="loadingStore.loadingText"
    :fullscreen="true"
  />
  <RouterView />
</template>

<style scoped></style>
